import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared.module';
import { ViewsModule } from '../views.module';
import { SortDropDownComponent } from './sort-drop-down/sort-drop-down.component';
import { SortIconItemComponent } from './sort-icon-item/sort-icon-item.component';

@NgModule({
  imports: [SharedModule, ViewsModule],
  declarations: [SortIconItemComponent, SortDropDownComponent],
  exports: [SortIconItemComponent, SortDropDownComponent],
})
export class SortElementsModule {}
